// extracted by mini-css-extract-plugin
export var sale_description = "sale_description_section-module--sale_description--e1fdb";
export var sale_description_text = "sale_description_section-module--sale_description_text--c6737";
export var steam_logo = "sale_description_section-module--steam_logo--d070f";